import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import ProductDetailsTwo from "../components/ProductDetailsTwo";
import NewArrivalTwo from "../components/NewArrivalTwo";
import Footer from "../components/Footer";
import ScrollToTop from "react-scroll-to-top";
import NewsletterTwo from "../components/NewsletterTwo";


const ProductDetailsPageOne = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="var(--brand-primary)" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderThree */}
      <HeaderThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"Product Details"} />

      {/* ProductDetailsTwo */}
      <ProductDetailsTwo />

      {/* NewArrivalTwo */}
      <NewArrivalTwo />
      
      {/* NewsletterTwo */}
      <NewsletterTwo />
      
      {/* Footer */}
      <Footer />

    </>
  );
};

export default ProductDetailsPageOne;